// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2926":"6b52be8904071407","6663":"326bf7d03284dc5e"}[chunkId] + ".js";
};